import 'twin.macro';
import React from 'react';
import { Square3Stack3DIcon } from '@heroicons/react/24/outline';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';
import { tagBackgroundColors, tagTextColor } from 'styles/userConstants';
import { css } from 'twin.macro';

export function CycleIcon(props: IconProps) {
  return (
    <Square3Stack3DIcon
      tw="p-1 rounded-lg"
      css={[
        css`
          background-color: ${tagBackgroundColors['mandarine-quiet']};
          color: ${tagTextColor.mandarine};
        `,
      ]}
      className={props.className}
      {...props}
    />
  );
}
